import { T_APP_CONFIG_CHECKER_PAGE_CONSTANTS } from './TYPES'

const DE_APP_CONFIG_CHECKER_PAGE_CONSTANTS: T_APP_CONFIG_CHECKER_PAGE_CONSTANTS =
  {
    OPTIONAL_UPDATE_HEADER: 'Update verfügbar',
    OPTIONAL_UPDATE_DESCRIPTION:
      'Um die neuesten Funktionen und Verbesserungen zu nutzen, aktualisieren Sie bitte die App.',
    OPTIONAL_UPDATE_CONFIRM_BTN_TEXT: 'Aktualisieren',
    OPTIONAL_UPDATE_CANCEL_BTN_TEXT: 'Nicht jetzt',
    FORCE_UPDATE_HEADER: 'Update erforderlich',
    FORCE_UPDATE_DESCRIPTION:
      'Eine neue Version der App ist verfügbar und wird benötigt, um fortzufahren. Bitte jetzt aktualisieren, um weiterzumachen.',
    FORCE_UPDATE_CONFIRM_BTN_TEXT: 'Jetzt aktualisieren'
  }

export default DE_APP_CONFIG_CHECKER_PAGE_CONSTANTS
